/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UserInfo } from '../models/UserInfo';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AuthenticationService {
    /**
     * User registration
     * Register a new user account
     * @returns any Registration successful
     * @throws ApiError
     */
    public static registerUser({
        requestBody,
    }: {
        requestBody: {
            /**
             * Username for the new account (3-100 characters, alphanumeric with underscores and hyphens)
             */
            username: string;
            /**
             * Password (minimum 8 characters, at least one letter and one number)
             */
            password: string;
            /**
             * Email address (optional)
             */
            email?: string;
            /**
             * Full name (optional)
             */
            fullName?: string;
        },
    }): CancelablePromise<{
        /**
         * JWT access token
         */
        token?: string;
        /**
         * Refresh token for token renewal
         */
        refreshToken?: string;
        /**
         * Token expiration timestamp
         */
        expiresAt?: string;
        user?: UserInfo;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/register',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                409: `Conflict - Username or email already exists`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * User login
     * Authenticate user and return JWT token
     * @returns any Login successful
     * @throws ApiError
     */
    public static createLogin({
        requestBody,
    }: {
        requestBody: {
            /**
             * Username for authentication
             */
            username: string;
            /**
             * User password
             */
            password: string;
        },
    }): CancelablePromise<{
        /**
         * JWT access token
         */
        token?: string;
        /**
         * Refresh token for token renewal
         */
        refreshToken?: string;
        /**
         * Token expiration timestamp
         */
        expiresAt?: string;
        user?: UserInfo;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/login',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Invalid credentials`,
            },
        });
    }
    /**
     * User logout
     * Revoke current JWT token
     * @returns any Logout successful
     * @throws ApiError
     */
    public static createLogout(): CancelablePromise<{
        message?: string;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/logout',
            errors: {
                401: `Unauthorized - No token provided or invalid token`,
            },
        });
    }
    /**
     * Refresh JWT token
     * Get new JWT token using refresh token
     * @returns any Token refreshed successfully
     * @throws ApiError
     */
    public static refresh({
        requestBody,
    }: {
        requestBody: {
            /**
             * Valid refresh token
             */
            refreshToken: string;
        },
    }): CancelablePromise<{
        /**
         * New JWT access token
         */
        token?: string;
        /**
         * New refresh token
         */
        refreshToken?: string;
        /**
         * New token expiration timestamp
         */
        expiresAt?: string;
        user?: UserInfo;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/refresh',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized access`,
            },
        });
    }
    /**
     * Delete user account
     * Delete a user account and all associated data. Only admin users can perform this action.
     * @returns any User deleted successfully
     * @throws ApiError
     */
    public static deleteUser({
        userId,
    }: {
        /**
         * ID of the user to delete
         */
        userId: string,
    }): CancelablePromise<{
        message?: string;
    }> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/users/{user_id}',
            path: {
                'user_id': userId,
            },
            errors: {
                401: `Unauthorized - Authentication required`,
                403: `Forbidden - Insufficient privileges`,
                404: `User not found`,
                500: `Internal server error`,
            },
        });
    }
}
